

export function keyify(s) {
	return (s + '').replace(/[-\s]*/g, '')
}